export class AppUILabels {
    static readonly CDCR_LABEL = 'CDCR#';
}

/** @deprecated Use `AppUILabels` instead. */
export { AppUILabels as BitsUILabels };
